import { Maybe } from '@websky/graphql';
import { compareAsc, toDate, parseISO, isWithinInterval } from 'date-fns';

export const safeAddDays = (date: Date | string, days: number): Date => {
	const newDate = date instanceof Date ? toDate(date) : parseISO(date);

	newDate.setDate(newDate.getDate() + days);

	return newDate;
};

export const createDatesArray = (minDate: Date, maxDate: Date): Date[] => {
	let date = toDate(minDate);

	const datesArray: Date[] = [];

	datesArray.push(minDate);

	while (compareAsc(maxDate, date) === 1) {
		date = safeAddDays(date, 1);

		datesArray.push(date);
	}

	return datesArray;
};

export const isDateInRange = (date: Date, availableDateRange?: [Maybe<Date>, Maybe<Date>]): boolean => {
	if (!availableDateRange) {
		return true;
	}

	const [start, end] = availableDateRange;

	if (start && end) {
		return isWithinInterval(date, { start, end });
	}

	if (start) {
		return date >= start;
	}

	if (end) {
		return date <= end;
	}

	return true;
};

/**
 * Ширина одного «шага» между днями в контейнере.
 * Сначала считаем расстояние между offsetLeft соседних слотов (учитывает gap),
 * иначе — ширину первого элемента.
 */
export const getDayStep = (daysContainer: HTMLElement) => {
	if (daysContainer.children.length >= 2) {
		const first = daysContainer.children[0] as HTMLElement;
		const second = daysContainer.children[1] as HTMLElement;
		const step = second.offsetLeft - first.offsetLeft;

		if (step > 0) {
			return step;
		}
	}

	const first = daysContainer.firstElementChild as HTMLElement | null;

	return first?.offsetWidth ?? 0;
};

/** Помещаются ли все дни во viewport */
export const isAllDaysFit = (viewport: HTMLElement, realScrollWidth: number) =>
	realScrollWidth > 0 && realScrollWidth <= viewport.clientWidth;
